import React, { useState, useEffect } from "react";
import { useLanguage, useSite } from "../../../contexts";
import { Icon } from "semantic-ui-react";
import "../../../components/Admin/ObjectivesAndBaseline/ObjectivesAndBaseline.scss";
import { ObjectivesAndBaseline } from "../../../components/Admin/ObjectivesAndBaseline/ObjectivesAndBaseline";
import { useAuth } from "../../../hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";
import { isAdmin, isMaster } from "../../../utils/checkPermission";

// `text` sale de las traducciones (t(key)) al renderizar, no acá — estos
// keys ("water", "effluent", etc.) ya existen en los .json de i18n.
const QUESTIONNAIRE_OPTIONS = [
  { key: "water",        value: "/admin/data/waterforms" },
  { key: "effluent",     value: "/admin/data/effluentforms" },
  // { key: "air", value: "/admin/data/airemissionsforms", disabled: true },
  { key: "energy",       value: "/admin/data/energyforms" },
  { key: "baseline",     value: "/admin/data/baseline" },
  // { key: "envobjetives", value: "/admin/data/environmentalobjetives" },
  { key: "production",   value: "/admin/data/productionforms" },
  { key: "waste",        value: "/admin/data/wasteforms" },
  { key: "social",       value: "/admin/data/socialforms" },
  { key: "fuel",         value: "/admin/data/fuelsforms" },
];

export function ObjetivesAndBaseline() {
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();
  const {
    accessToken,
    user: { role },
  } = useAuth();
  const [siteSelected, setSiteSelected] = useState(null);

  const onReload = () => setReload((prevState) => !prevState);

  const { translations, language } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const location = useLocation();

  const siteContext = useSite().site;

  useEffect(() => {
    (async () => {
      try {
        if (siteContext !== "") {
          setSiteSelected(siteContext);
        }
      } catch (error) {
        console.error(error);
        setSiteSelected(null);
      }
    })();
  }, [siteContext]);

  const content =
    siteSelected === null && (isMaster(role) || (isAdmin(role) && !siteSelected)) ? (
      <div className="no-site-warning">
        <Icon name="warning sign" size="big" />
        <p>{t("select_company_site_from_header")}</p>
      </div>
    ) : (
      <ObjectivesAndBaseline site={siteSelected} />
    );

  return (
    <div className="baseline-page">
      <div className="baseline-header">
        <Dropdown
            className="baseline-questionnaire-dropdown"
            options={QUESTIONNAIRE_OPTIONS
              .map((opt) => ({ ...opt, text: t(opt.key) }))
              .sort((a, b) => a.text.localeCompare(b.text, language))}
            selection
            onChange={(_, data) => navigate(data.value)}
            value="/admin/data/baseline"
          />
        <div className="baseline-header-actions">
          {/* <span className="baseline-year-badge">{currentYear}</span>
          <button className="baseline-add-btn" onClick={onOpenCloseModal}>+</button> */}
        </div>
      </div>
      <div className="baseline-content">
        {content}
      </div>
    </div>
  );
}
